/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: classOfServicesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Class of Services module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { requestTelephonyModule, CLASS_OF_SERVICES_ENDPOINT } from './api';

/**
 * Shared helpers for Class of Services module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Class of Service in the form.
 * Pattern: /pbx/class-of-service/class/new?duplicate={id}
 */
export const getClassOfServiceDuplicateUrl = (id: string | number): string =>
  `/pbx/class-of-service/class/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Class of Service id.
 */
export const navigateToClassOfServiceDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getClassOfServiceDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Class of Service by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteClassOfServiceById = async (id: string | number): Promise<void> => {
  await requestTelephonyModule<null>(
    `${CLASS_OF_SERVICES_ENDPOINT}/${id}`,
    'Failed to delete Class of Service',
    { method: 'DELETE' },
  );
};



